import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function TrendingDownIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="M16 17h6v-6" />
      <path d="m22 17-8.5-8.5-5 5L2 7" />
    </StrokeIcon>
  );
}
